import { FaTimes } from "react-icons/fa";
import { resolverImagenUrl } from "../../utils/imagen";

export default function ImagenLightbox({ src, alt, onClose }) {
  if (!src) return null;

  return (
    <div
      className="fixed inset-0 z-50 bg-black/90
                 flex items-center justify-center
                 px-4"
      onClick={onClose}  
    >
      {/* BOTÓN CERRAR */}
      <button
        onClick={onClose}
        className="absolute top-4 right-4
                   text-white text-xl
                   bg-black/60 hover:bg-red-600
                   p-2 rounded-full z-10"
      >
        <FaTimes />
      </button>

      {/* IMAGEN */}
      <img
        src={resolverImagenUrl(src)}
        alt={alt}
        className="max-h-[90vh] max-w-full
                   object-contain
                   rounded-lg shadow-2xl"
        onClick={(e) => e.stopPropagation()} 
      />
    </div>
  );
}
